import React from "react";
import "../styles/NotFound.css";

const NotFound = () => {
  return (
    <div className="notfound-container">
        <div>
      <p className="notfound-error">
        <span className="leaf-icon"></span> 404 Error
      </p>
      <h1 className="notfound-title">
        Oops, you’ve <br />
        taken a <em>wrong</em> turn!
      </h1>
      <p className="notfound-text">
        It looks like the page you’re searching for doesn’t exist (or maybe we moved it).
        Let’s get you back on track—use the menu or head back to the homepage to continue exploring.
      </p>
      <a href="/" className="notfound-btn">
        Go to home <span className="btn-icon">↗</span>
      </a>
        </div>

    </div>
  );
};

export default NotFound;